import React from "react";

const Footer = () => {
  return (
    <footer className="text-center">
      <h4>HIGHTECH © {new Date().getFullYear()}</h4>
    </footer>
  );
};

export default Footer;
